import { Typography, Icon } from '@sanlam-glacier/app-common/components';
import style from './banner-staysafe.module.scss';
import { useConfig } from 'providers/config/ConfigProvider';
import { useLocation } from 'react-router-dom';
import { routes } from 'routes/route-paths';

export const BannerStaySafe = () => {
  const env = useConfig();
  const title = `Stay safe online. `;
  const description = `Now more than ever, it's important to be cybersafe. See Sanlam's tips to help you stay safe online.`;

  const currentLocation = useLocation();
  const onDashboardPage = currentLocation.pathname.endsWith(routes.dashboard);

  if (!onDashboardPage) {
    return <></>;
  }

  return (
    <div className={style.bannerStaysafe}>
      <Typography
        align={Typography.ALIGN.CENTER}
        color={Typography.COLOR.TERTIARY}
        variant={Typography.VARIANT.B4}
      >
        <span style={{ fontWeight: Typography.WEIGHT.BOLD }}>{title}</span>
        <span>{description}</span>
      </Typography>
      <a
        href={env.redirects.StaySafeLearnMore}
        target='_blank'
        rel='noreferrer'
        aria-label={title}
        className={style.bannerStaysafeLink}
      >
        <Typography
          color={Typography.COLOR.PRIMARY}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.BOLD}
        >
          Learn more
        </Typography>
        <Icon icon='action-2_open-in-new' className={style.bannerStaysafeIcon} />
      </a>
    </div>
  );
};
